module.exports = function getResource(label, vars = []) {
    let resources = {
        please: 'Veuillez',
        signIn: 'ouvrir une session',
        review: 'pour consulter cette rubrique.'
    };

    return resources[label];
};
